import { TextStyleKit } from '@tiptap/extension-text-style'
import { CharacterCount } from '@tiptap/extensions'
import { generateHTML, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { marked } from 'marked'
import { useEffect } from 'react'
import { Indent } from './extensions/indentExtension'

function isHtml(str: string) {
	const blockTypes = ['<p>', '<h1>', '<h2>', '<h3>']
	return blockTypes.some((blockType) => str.includes(blockType))
}

function loadRichTextContent(str: string) {
	const isMarkdown = !isHtml(str)

	// Compatibility with previous markdown version
	if (isMarkdown) {
		return marked.parse(str, { async: false })
	}

	return str
}

const extensions = [TextStyleKit, StarterKit, Indent, CharacterCount]

export function useRichTextContent({
	content = '',
	onUpdate,
	editable = true,
	reloadOnContentChange = false,
}: {
	onUpdate?: (value: string) => void
	content?: string
	editable?: boolean
	reloadOnContentChange?: boolean
}) {
	const editor = useEditor({
		extensions,
		content,
		editable,

		onUpdate: ({ editor }) => {
			const html = generateHTML(editor.getJSON(), extensions)
			onUpdate?.(html)
		},
	})

	useEffect(() => {
		if (!editor) return
		if (!reloadOnContentChange) return

		const updated = loadRichTextContent(content)
		const current = editor.getHTML()
		if (current.trim() === updated.trim()) {
			return
		}
		editor.commands.setContent(updated, { emitUpdate: false })
	}, [editor, content, reloadOnContentChange])

	return editor
}
